export default {
  saveRecipeAs: {
    header: 'Save recipe as',
  },
};
